module.exports = __webpack_public_path__ + "img/COC.6ac96df8.svg";